import { numConvert, calculation } from "@/method";
import Echarts from "echarts";
import moment from "moment";
const color = ['#4c9bf2', '#4AC18E', '#D9534F', '#67A8E4'];

export default function (data) {
    const listName = ['ava', 'sold', 'revpar', 'rev', 'total'];
    data.push({
        hotel_name: "Total"
    });
    const len = data.length - 1;
    listName.forEach(name => {
        data[len][name] = data.reduce((a, b, i) => a += i < len ? numConvert(b[name]) : 0, 0).toFixed(4);
    });
    data.forEach((item, i) => {
        data[i].revper = calculation(item.rev, item.total, 4);
        data[i].occ = calculation(item.sold, item.ava, 4);
        data[i].adr = calculation(item.rev, item.sold, 2);
        data[i].revpar = calculation(item.rev, item.ava, 2);
    });

    return data
}

export const setKarte = ({
    name,
    dataY,
    id,
    dataX
}, isOnResize) => {
    var myChart = Echarts.init(document.getElementById(id));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        title: {
            text: name,
            textStyle: {
                align: 'left',
                color: '#333',
                fontSize: 20,
            },
            top: '5%',
            left: 'left',
        },
        grid: {
            bottom: 80
        },
        legend: {
            top: '30',
            data: ['this year', 'last year']
        },
        color,
        xAxis: {
            splitLine: {
                lineStyle: {
                    show: true,
                }
            },
            "axisLabel": {
                textStyle: {
                    fontSize: 12,
                    color: '#000'
                },
                minInterval: 1,
                rotate: -30
            },
            data: dataX,

        },
        yAxis: {
            name: name == 'Occ%' ? '%' : '',
            type: 'value'
        },
        tooltip: {
            trigger: 'axis',
            // formatter: `{b}日<br/>{a} : {c}${name == 'Occ%' ? '%' : ''}` 
        },
        toolbox: {
            id,
            right: 20,
            feature: {
                saveAsImage: {
                    type: 'png',//	设置图片格式 png或者'jpeg
                    name,
                    backgroundColor: '#FFF',
                    excludeComponents: ['toolbox'],
                    show: true,
                    title: '保存图片',
                }
            }
        },
        series: [{
            name: "this year",
            type: 'bar',
            barMaxWidth: 20,
            data: dataY[0],

        }, {
            name: "last year",
            type: 'bar',
            barMaxWidth: 20,
            data: dataY[1],
        }]
    };

    myChart.setOption(option);
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/summary/compute.js